export const SET_SHOWN_IMAGE_DIMENSIONS = 'SET_SHOWN_IMAGE_DIMENSIONS';

const areShownDimensionsEqual = (previous = {}, next = {}) =>
  previous.width === next.width &&
  previous.height === next.height &&
  previous.x === next.x &&
  previous.y === next.y &&
  previous.abstractX === next.abstractX &&
  previous.abstractY === next.abstractY &&
  previous.scaledBy === next.scaledBy;

const setShownImageDimensions = (state, payload) => {
  const nextShownImageDimensions = {
    ...state.shownImageDimensions,
    ...payload.shownImageDimensions,
  };
  const nextDesignLayer = payload.designLayer || state.designLayer;
  const nextPreviewGroup = payload.previewGroup || state.previewGroup;

  if (
    areShownDimensionsEqual(state.shownImageDimensions, nextShownImageDimensions) &&
    nextDesignLayer === state.designLayer &&
    nextPreviewGroup === state.previewGroup
  ) {
    return state;
  }

  return {
    ...state,
    shownImageDimensions: nextShownImageDimensions,
    designLayer: nextDesignLayer,
    previewGroup: nextPreviewGroup,
  };
};

export default setShownImageDimensions;
